module.exports = __webpack_public_path__ + "img/ic-playlists.41673252.svg";